import { ReactNode, useCallback } from 'react';
import {
  CeCertificateStudentsFilters,
  CeCertificateStudentsResponse,
} from '../types';
import { getCertificateStudents } from '../api';
import { useParams } from 'react-router-dom';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';

const {
  FetchProvider: CertificateStudentsProvider,
  useFetch: useCertificateStudents,
} = createFetchContext<
  CeCertificateStudentsFilters,
  CeCertificateStudentsResponse
>();

interface Props {
  children: ReactNode;
  defaultQuery?: CeCertificateStudentsFilters;
  fetchImmediately?: boolean;
}

export const CertificateStudentsLoader = ({
  children,
  defaultQuery = { page: 1, items_per_page: 10 },
  fetchImmediately = true,
}: Props) => {
  const { ceAcademicOfferId } = useParams<{ ceAcademicOfferId: string }>();

  const requestFn = useCallback(
    (filters?: CeCertificateStudentsFilters) =>
      getCertificateStudents(Number(ceAcademicOfferId), filters ?? {}),
    [ceAcademicOfferId],
  );

  return (
    <CertificateStudentsProvider
      request={requestFn}
      defaultQuery={defaultQuery}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </CertificateStudentsProvider>
  );
};

export { useCertificateStudents };
